/**
 * Типографские правила набора.
 *
 * Живут отдельно от экранов и применяются ко всем заголовкам и подписям
 * разом: правило, применённое руками в одном месте, через неделю забывают
 * в трёх других.
 */

/** Короткие слова, после которых перенос строки запрещён. */
const SHORT = 3;

/**
 * Убрать висячие предлоги.
 *
 * Предлог или союз в конце строки отрывается от своего слова, и строка
 * заканчивается словом, которое ничего не значит само по себе:
 * «уникальный мерч со| своим питомцем». Вместо обычного пробела после
 * коротких слов ставим неразрывный — перенос уезжает вместе с предлогом.
 *
 * То же правило для дефиса и для числа с единицей: «1 шт» и «4 200 ₽»
 * не разрываются.
 */
export function fixHangers(text: string): string {
  return (
    text
      // Короткое слово в начале строки или после пробела — приклеиваем
      // к следующему.
      .replace(
        new RegExp(`(^|\\s)([А-Яа-яЁёA-Za-z]{1,${SHORT}})\\s+`, 'g'),
        (_match, before: string, word: string) => `${before}${word}\u00A0`,
      )
      // Число и то, что за ним: рубли, штуки, размеры.
      .replace(/(\d)\s+(?=[₽A-Za-zА-Яа-яЁё])/g, '$1\u00A0')
  );
}
